"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchMetamaskChain = void 0;
var chains_1 = require("../../../chains");
/**
 * Requests Metamask to switch the network. Can be used to ask user to switch when they are on the wrong network.
 */
function switchMetamaskChain(_a) {
    var _b;
    var toChain = _a.toChain, providerUrl = _a.providerUrl, metaProvider = _a.metaProvider;
    return __awaiter(this, void 0, void 0, function () {
        var chainStr, error_1, chain, addError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    chainStr = "0x".concat(chains_1.idByChain[toChain].toString(16));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 8]);
                    return [4 /*yield*/, metaProvider.request({
                            method: "wallet_switchEthereumChain",
                            params: [{ chainId: chainStr }],
                        })];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 8];
                case 3:
                    error_1 = _c.sent();
                    if (!(error_1.code === 4902)) return [3 /*break*/, 7];
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    chain = chains_1.chains[toChain];
                    return [4 /*yield*/, window.ethereum.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: chainStr,
                                    chainName: chain.name,
                                    rpcUrls: [providerUrl],
                                    blockExplorerUrls: [chain.explorer],
                                    nativeCurrency: {
                                        name: chain.token.symbol,
                                        symbol: chain.token.symbol,
                                        decimals: 18,
                                    },
                                },
                            ],
                        })];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    addError_1 = _c.sent();
                    // Skip errors like "Request of type 'wallet_addEthereumChain' already pending"
                    if ((_b = addError_1 === null || addError_1 === void 0 ? void 0 : addError_1.message) === null || _b === void 0 ? void 0 : _b.includes("already pending")) {
                        return [2 /*return*/];
                    }
                    console.error(addError_1);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.switchMetamaskChain = switchMetamaskChain;
